/**
 * RAM → RCS (Cockpit) deep links using `S_COCKPIT_URL` from runtime config.
 * Paths align with `CCSRouteMap` in `@condo/domain` (single source of truth with cockpit router).
 *
 * Asset/MFH-specific builders live in `entities/asset/lib/cockpit-mfh-links.ts`.
 */
import { CCSRouteMap, resolveRoutePath } from '@condo/domain';

export function normalizeCockpitBaseUrl(baseUrl: string | undefined | null): string | null {
    const t = (baseUrl ?? '').trim();
    if (!t) return null;
    return t.replace(/\/$/, '');
}

/** `/accounting/invoices/:invoiceId` — global invoice detail in Cockpit. */
export function cockpitInvoiceDetailUrl(baseUrl: string | undefined | null, invoiceId: number): string | null {
    const b = normalizeCockpitBaseUrl(baseUrl);
    if (!b) return null;
    return resolveRoutePath(CCSRouteMap['invoice.details'], { params: { invoiceId: String(invoiceId) }, baseUrl: b });
}

/** `/estates/:estateId/details` — unit (estate) detail in Cockpit. */
export function cockpitEstateDetailsUrl(baseUrl: string | undefined | null, estateId: number): string | null {
    const b = normalizeCockpitBaseUrl(baseUrl);
    if (!b) return null;
    return resolveRoutePath(CCSRouteMap.oneEstate, { params: { estateId: String(estateId) }, baseUrl: b });
}

/** `/contacts/:contactId/info` — contact detail in Cockpit. */
export function cockpitContactDetailUrl(baseUrl: string | undefined | null, contactId: number | string): string | null {
    const b = normalizeCockpitBaseUrl(baseUrl);
    if (!b) return null;
    return resolveRoutePath(CCSRouteMap['contactDetail.info'], {
        params: { contactId: String(contactId) },
        baseUrl: b,
    });
}
/** `/credit-line-portfolio/:creditLinePortfolioId` — credit line in Cockpit. */
export function cockpitCreditLinePortfolioUrl(baseUrl: string | undefined | null, creditLinePortfolioId: number): string | null {
    const b = normalizeCockpitBaseUrl(baseUrl);
    if (!b) return null;
    return resolveRoutePath(CCSRouteMap['credit-line-portfolio.one'], {
        params: { creditLinePortfolioId: String(creditLinePortfolioId) },
        baseUrl: b,
    });
}

/** `/portfolio/:portfolioId` — retail portfolio in Cockpit. */
export function cockpitPortfolioUrl(baseUrl: string | undefined | null, portfolioId: number): string | null {
    const b = normalizeCockpitBaseUrl(baseUrl);
    if (!b) return null;
    return resolveRoutePath(CCSRouteMap['one.portfolio'], { params: { portfolioId: String(portfolioId) }, baseUrl: b });
}

/** `/sales-packages/:salesPackageId/overview` — sales package in Cockpit. */
export function cockpitSalesPackageOverviewUrl(baseUrl: string | undefined | null, salesPackageId: number): string | null {
    const b = normalizeCockpitBaseUrl(baseUrl);
    if (!b) return null;
    return resolveRoutePath(CCSRouteMap['sales-package.overview'], { params: { salesPackageId: String(salesPackageId) }, baseUrl: b });
}
